angular.module('unica_invitation.invitation_services')

.factory('InvitationDeleteService', function ($http, getBaseApiURL) {

	var invitationDeleteService = {};

	invitationDeleteService.delete = function (invitationData) {

		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/invitation/delete/' + invitationData.id,
			data: invitationData
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};


	invitationDeleteService.deleteInvitationTagAttachment = function ( invitationId, eventTagId )
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-tag/delete-attachment/' + invitationId,
			data: {
				invitation_id: invitationId,
				event_tag_id: eventTagId,
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.eventTags;
			}

		});
	};

	return invitationDeleteService;
});